import { useEffect, useState } from "react";
import visibleImg from "../../../../../picture/Visible.png";
import deleteImg from "../../../../../picture/delete.png";
import { useGlobalContext } from "../../../../../Context/Context";
import axios from "axios";

const styles = {
  cell: { padding: "5px", textAlign: "center", fontSize: "14px" },
  flex: { display: "flex", alignItems: "center", justifyContent: "center" },
};

function Gradilista({
  currentTab,
  setGradilisteId,
  setMesec,
  setGodina,
  onRefresh,
  data = [],
}) {
  const { dictionary } = useGlobalContext();

  const handlePreview = (id) => {
    setGradilisteId(id);
    setMesec(new Date().getMonth() + 1);
    setGodina(new Date().getFullYear());
  };

  return (
    <table style={{ width: "100%" }}>
      <thead>
        <tr>
          <th style={{ ...styles.cell, width: "10%" }}>
            {dictionary["redniBr"]}
          </th>
          <th style={styles.cell}>{dictionary["gradilisteRadiliste"]}</th>
          <th style={{ ...styles.cell, width: "15%" }}>
            {dictionary["pocetak"]}
          </th>
          <th style={{ ...styles.cell, width: "15%" }}>
            {dictionary["poslednje"]}
          </th>
          <th style={{ width: "40px" }}></th>
          <th style={{ width: "40px" }}></th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, i) => (
          <tr key={item.id}>
            <td style={styles.cell}>{i + 1}.</td>
            <td style={styles.cell}>{item.naziv}</td>
            <td style={styles.cell}>{item.pocetak}</td>
            <td style={styles.cell}>{item.poslednje}</td>
            <td
              onClick={() => handlePreview(item.id)}
              style={{ width: "40px", cursor: "pointer" }}
            >
              <div style={styles.flex}>
                <img src={visibleImg} style={{ width: "30px" }} />
              </div>
            </td>
            <td
              onClick={() => onRefresh && onRefresh(item.id)}
              style={{ width: "40px", cursor: "pointer" }}
            >
              <div style={styles.flex}>
                <img src={deleteImg} style={{ width: "20px" }} />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default Gradilista;
